import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthenticatedLayout } from '../app/layouts/AuthenticatedLayout';
import AuthLoginPage from '../features/auth/pages/AuthLoginPage';
import VerifyEmailPage from '../features/auth/pages/VerifyEmailPage';
import CompleteUserPage from '../features/auth/pages/CompleteUserPage';
import ForgotPasswordPage from '../features/auth/pages/ForgotPasswordPage';
import ResetPasswordPage from '../features/auth/pages/ResetPasswordPage';
import EmailActionPage from '../features/auth/pages/EmailActionPage';
import NotFoundPage from '../features/system/pages/NotFoundPage';
import AdminCondominiumsPage from '../features/admin/pages/AdminCondominiumsPage';
import AdminCondominiumDetailsPage from '../features/admin/pages/AdminCondominiumDetailsPage';
import AdminUsersPage from '../features/admin/pages/AdminUsersPage';
import MyParkingSpotsPage from '../features/my-parking-spots/pages/MyParkingSpotsPage';
import AvailableSpotsPage from '../features/available-spots/pages/AvailableSpotsPage';
import DashboardPage from '../features/dashboard/pages/DashboardPage';
import EditProfilePage from '../features/profile/pages/EditProfilePage';
import MySpotUsagesPage from '../features/spot-usages/pages/MySpotUsagesPage';
import PrivateRoute from './guards/PrivateRoute';
import EmailVerifiedGate from './guards/EmailVerifiedGate';
import CustomerCompletedGate from './guards/CustomerCompletedGate';
import AdminRoute from './guards/AdminRoute';
import CondominiumAdminRoute from './guards/CondominiumAdminRoute';
import RootRedirect from './guards/RootRedirect';
import LandingPage from '../features/marketing/pages/LandingPage';
import PrivacyPolicyPage from '../features/marketing/pages/PrivacyPolicyPage';

export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/site" element={<LandingPage />} />
        <Route path="/privacidade" element={<PrivacyPolicyPage />} />
        <Route path="/login" element={<AuthLoginPage />} />
        <Route path="/email-action" element={<EmailActionPage />} />
        <Route path="/" element={<RootRedirect />} />

        <Route
          path="/complete-user"
          element={
            <PrivateRoute>
              <EmailVerifiedGate>
                <CustomerCompletedGate>
                  <CompleteUserPage />
                </CustomerCompletedGate>
              </EmailVerifiedGate>
            </PrivateRoute>
          }
        />

        <Route
          path="/verify-email"
          element={
            <PrivateRoute>
              <VerifyEmailPage />
            </PrivateRoute>
          }
        />

        <Route path="/reset-password" element={<ResetPasswordPage />} />

        <Route path="/forgot-password" element={<ForgotPasswordPage />} />

        <Route path="/404" element={<NotFoundPage />} />

        <Route
          element={
            <PrivateRoute>
              <EmailVerifiedGate>
                <AuthenticatedLayout />
              </EmailVerifiedGate>
            </PrivateRoute>
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/my-parking-spots" element={<MyParkingSpotsPage />} />
          <Route path="/available-spots" element={<AvailableSpotsPage />} />
          <Route path="/my-spot-usages" element={<MySpotUsagesPage />} />
          <Route path="/edit-profile" element={<EditProfilePage />} />

          <Route
            path="/admin/condominiums"
            element={
              <CondominiumAdminRoute>
                <AdminCondominiumsPage />
              </CondominiumAdminRoute>
            }
          />
          <Route
            path="/admin/condominiums/:id"
            element={
              <CondominiumAdminRoute>
                <AdminCondominiumDetailsPage />
              </CondominiumAdminRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <AdminRoute>
                <AdminUsersPage />
              </AdminRoute>
            }
          />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
